










































































































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import GiganautVueForm from '@/components/Shared/GiganautVueForm';
import { FirebaseError } from 'firebase/app';
import { getAuth, User as FirebaseUser, signInWithEmailAndPassword, signOut, verifyPasswordResetCode, confirmPasswordReset, checkActionCode, applyActionCode } from "firebase/auth";


@Component({
  name: 'FirebaseAuthHandler', components: { Alert }
})
export default class extends GiganautVueForm {
  
  public mode = '';
  public actionCode = '';
  public continueUrl = '';
  public lang = '';
  public email = '';
  public newPassword = '';
  public confirmPassword = '';
  public showLoginButton = true;
  auth = getAuth();

	beforeMount() {
    // Get the action to complete.
    this.mode = this.$route.query.mode.toString();
    // Get the one-time code from the query parameter.
    this.actionCode = this.$route.query.oobCode.toString();
    // (Optional) Get the continue URL from the query parameter if available.
    if (this.$route.query.continueUrl) {
      this.continueUrl = this.$route.query.continueUrl.toString();
    }
    // (Optional) Get the language code if available.
    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang.toString() || 'en';
    }
    //const auth = getAuth();
    // Verify the password reset code is valid.
    if (this.mode === "resetPassword") {
      verifyPasswordResetCode(this.auth, this.actionCode).then((email) => {
        this.email = email;
        }).catch((error: FirebaseError) => {
          // Error occurred during confirmation. The code might have expired.
            AppModule.handleFirebaseError(error);
            this.mode = this.mode + "Error";
        });
    }
    if (this.mode === "verifyEmail") {
      checkActionCode(this.auth, this.actionCode).then((actionDetails) => {
        this.email = actionDetails.data.email;
        }).catch((error: FirebaseError) => {
          // Error occurred during check. The code might have expired. 
            AppModule.handleFirebaseError(error);
            this.mode = this.mode + "Error";
        });
    }

  }

  resetPassword() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    confirmPasswordReset(this.auth, this.actionCode, this.newPassword).then((resp) => {
        if (this.continueUrl.toLowerCase().includes("portal") || this.continueUrl.toLocaleLowerCase().includes("localhost")) {
        //Allow user to navigate to portal
        this.showLoginButton = true;
      }  else {
        this.showLoginButton = false;
      }
      this.mode = this.mode + "Success";
      //Password reset has been confirmed and new password updated.
      // TODO: Display a link back to the app, or sign-in the user directly
      // if the page belongs to the same domain as the app:
      // auth.signInWithEmailAndPassword(accountEmail, newPassword);

    }).catch((error: FirebaseError) => {
      AppModule.handleFirebaseError(error);
    });
  }

  verifyEmailAddress() {
      applyActionCode(this.auth, this.actionCode).then((resp) => {
         if (this.continueUrl.toLowerCase().includes("portal") || this.continueUrl.toLocaleLowerCase().includes("localhost")) {
          //Allow user to navigate to portal
          this.showLoginButton = true;
        }  else {
          this.showLoginButton = false;
        }
        this.mode = this.mode + "Success";

      }).catch((error: FirebaseError) => {
        AppModule.handleFirebaseError(error);
      });
  }

  async navigateTologin() {
   this.$router.push({ name: PageNames.Login});
  }
}
